import { render, staticRenderFns } from "./dash_detail.vue?vue&type=template&id=1689d360&scoped=true&"
import script from "./dash_detail.vue?vue&type=script&lang=js&"
export * from "./dash_detail.vue?vue&type=script&lang=js&"
import style0 from "./dash_detail.vue?vue&type=style&index=0&id=1689d360&prod&scoped=true&lang=css&"
import style1 from "./dash_detail.vue?vue&type=style&index=1&id=1689d360&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1689d360",
  null
  
)

export default component.exports